/* import __COLOCATED_TEMPLATE__ from './line-of-credit-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();